namespace Matrix.Dashboards {
    export interface DashboardUserRow {
        DashboardCode?: string;
        Username?: string;
        Default?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DashboardCategoryCode?: string;
        DashboardNavigationPermission?: string;
    }

    export namespace DashboardUserRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'DashboardCode';
        export const localTextPrefix = 'Dashboards.DashboardUser';
        export const deletePermission = 'Administration:Dashboards';
        export const insertPermission = 'Administration:Dashboards';
        export const readPermission = 'Read:Dashboards';
        export const updatePermission = 'Administration:Dashboards';

        export declare const enum Fields {
            DashboardCode = "DashboardCode",
            Username = "Username",
            Default = "Default",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DashboardCategoryCode = "DashboardCategoryCode",
            DashboardNavigationPermission = "DashboardNavigationPermission"
        }
    }
}
